import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  styled,
} from "@mui/material";
import ServicesBox from "../ServicesBox";
import { Close } from "@mui/icons-material";
import { IBookingSettings } from "pages/booking/interface";

interface Props {
  open: boolean;
  onClose: () => void;
  services: Array<any>;
  onRemove: (serviceId: string, index: number) => void;
  bookingSettings: IBookingSettings;
}

const ServicesDialog = ({
  open,
  onClose,
  services,
  onRemove,
  bookingSettings,
}: Props) => {
  return (
    <BootstrapDialog
      fullWidth={true}
      sx={{
        margin: "0 auto",
        maxWidth: "500px",
        zIndex: 1399,
        "& .MuiBackdrop-root": { position: "absolute" },
        "& .MuiPaper-root": {
          boxShadow: "none",
          backgroundColor: "transparent",
          borderRadius: "12px",
        },
      }}
      onClose={onClose}
      maxWidth="sm"
      open={open}
    >
      <IconButton
        onClick={onClose}
        sx={{
          width: "37px",
          height: "37px",
          marginBottom: "-20px",
          marginLeft: "auto",
          backgroundColor: "#fff",
          "&:hover": {
            backgroundColor: "#e7e6e6",
          },
        }}
      >
        <Close sx={{ color: "#061340" }} />
      </IconButton>
      <DialogContent
        sx={{
          borderRadius: "12px",
          backgroundColor: "#EBF4FD",
          border: "1px solid #0B70E1",
          overflow: "hidden",
        }}
      >
        <Typography mb={2} color="#061340" fontSize={18} fontWeight={600}>
          YOUR SERVICES
        </Typography>
        <ServicesBox
          services={services}
          onRemove={onRemove}
          bookingSettings={bookingSettings}
        />
      </DialogContent>
    </BootstrapDialog>
  );
};

export default ServicesDialog;

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(3),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));
